<script lang="ts" setup>
import StorageService from '../../../runtime/services/StorageService';

const { $log } = useLogging();
const { $alert } = useAlerts();
const { $t } = useLocalization();

const emit = defineEmits<{
    (e: 'deleted', items: FileResource[]): void;
}>();

const resources = ref<FileResource[]>([]);
const modalRef = ref<any>(null);
const loading = ref(false);

const deleteResources = async (): Promise<void> =>
{
    try
    {
        loading.value = true;

        await StorageService.deleteResources(resources.value);

        if (resources.value.length > 1)
            $alert.success($t('[[[Wybrane elementy zostały usunięte.]]]'));
        else
            $alert.success($t('[[[Wybrany element został usunięty.]]]'));

        modalRef.value.hide();
        emit('deleted', resources.value);
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });
    }
    finally
    {
        loading.value = false;
    }
};

const showModal = (items: FileResource[]): void =>
{
    resources.value = items;
    modalRef.value.show();
};

defineExpose({
    showModal
});
</script>

<template>
    <IdeoModal
        ref="modalRef"
        :title="`${$t('[[[Usunięcie]]]')} ${resources.length > 1 ? $t('[[[wybranych elementów]]]') : $t('[[[wybranego elementu]]]')}`"
        hide-footer
        modal-class="filemanager-modal"
        backdrop-class="filemanager-backdrop"
    >
        <p>{{ $t('[[[Na pewno usunąć]]]') }} {{ resources.length > 1 ? $t('[[[wybrane elementy?]]]') : $t('[[[wybrany element?]]]') }}</p>

        <div class="alert alert-danger">
            <div v-for="resource in resources" :key="`${resource.resourceType}:${resource.id}`">
                {{ resource.name }} {{ resource.resourceType == 'file' ? `[${$filters.filesize(resource.contentLength)}]` : '' }}
            </div>
        </div>

        <div class="text-end">
            <ActionButton
                variant="light"
                icon="far fa-ban"
                :text="$t('[[[Anuluj]]]')"
                @click.prevent="modalRef.hide()"
            />
            <ActionButton
                variant="danger"
                icon="far fa-check"
                :loading="loading"
                :text="$t('[[[Usuń]]]')"
                @click.prevent="deleteResources"
            />
        </div>
    </IdeoModal>
</template>
